import { render, staticRenderFns } from "./AdminChatBubble.vue?vue&type=template&id=65760538&scoped=true"
import script from "./AdminChatBubble.vue?vue&type=script&lang=js"
export * from "./AdminChatBubble.vue?vue&type=script&lang=js"
import style0 from "./AdminChatBubble.vue?vue&type=style&index=0&id=65760538&prod&scoped=true&lang=css"
import style1 from "./AdminChatBubble.vue?vue&type=style&index=1&id=65760538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65760538",
  null
  
)

export default component.exports